export const LIMIT_ON_SELECTION = {
  country: 1,
  business_size: 1,
  user_company_profile: 1,
};

export const FORMORDER = {
  1: "FOUNDATIONAL_INFO",
  2: "PERSONA_INFO",
  3: "USER_COMPANY_INFO",
  4: "LINE_OF_BUSINESS_INFO_1",
  5: "BUSINESS_INFO_1",
  6: "LINE_OF_BUSINESS_INFO_2",
  7: "BUSINESS_INFO_2",
  8: "CONFORMATION_AND_COMPLETION",
};

export const LOB_ENUM = {
  EXPORT: "Export",
  IMPORT: "Import",
  EXPORT_AND_IMPORT: "Export and Import",
  BUSINESS_DEVELOPMENT: "Business Development (Logistics / Trade Finance)",
  RESEARCH_AND_ANALYTICS: "Research and Analytics",
  OTHER: "Other",
};

export const LOB_LABEL_MAP = {
  [LOB_ENUM.EXPORT]: "Exports::Identify potential buyers globally and monitor customers and competitors.",
  [LOB_ENUM.IMPORT]: "Procurement::Discover international suppliers, optimize sourcing costs, and monitor suppliers and competitors.",
  [LOB_ENUM.EXPORT_AND_IMPORT]: "Imports & Exports::Identify both potential buyers and suppliers worldwide.",
  [LOB_ENUM.BUSINESS_DEVELOPMENT]: "Prospecting::Find new leads and grow my sales pipeline using trade intelligence.",
  [LOB_ENUM.RESEARCH_AND_ANALYTICS]: "Trade Analysis::Monitor companies, analyze trade flows, and generate insights or reports.",
  [LOB_ENUM.OTHER]: "Other::Use trade intelligence data and insights to improve business operations.",
};

export const STEP_FIELD_MAPS = {
  FOUNDATIONAL_INFO: ["company_name", "phone_number", "country"],
  PERSONA_INFO: ["line_of_business"],
  USER_COMPANY_INFO: {
    [LOB_ENUM.IMPORT]: ["user_company_profile"],
    [LOB_ENUM.EXPORT]: ["user_company_profile"],
    [LOB_ENUM.EXPORT_AND_IMPORT]: ["user_company_profile"],
    [LOB_ENUM.BUSINESS_DEVELOPMENT]: null,
    [LOB_ENUM.RESEARCH_AND_ANALYTICS]: null,
    [LOB_ENUM.OTHER]: null,
  },
  LINE_OF_BUSINESS_INFO_1: {
    [LOB_ENUM.IMPORT]: ["imp_products_hscodes"],
    [LOB_ENUM.EXPORT]: ["exp_products_hscodes"],
    [LOB_ENUM.EXPORT_AND_IMPORT]: ["exp_imp_products_hscodes_exp"],
  },
  BUSINESS_INFO_1: {
    [LOB_ENUM.IMPORT]: ["imp_prospects", "imp_competitors"],
    [LOB_ENUM.EXPORT]: ["exp_prospects", "exp_customers", "exp_competitors"],
    [LOB_ENUM.EXPORT_AND_IMPORT]: ["exp_imp_prospects_exp", "exp_imp_customers_exp", "exp_imp_competitors_exp"],
    [LOB_ENUM.BUSINESS_DEVELOPMENT]: ["bd_countries", "bd_ports", "bd_industry_segments", "business_size"],
    [LOB_ENUM.RESEARCH_AND_ANALYTICS]: ["ra_countries", "ra_industry_segments"],
  },
  BUSINESS_INFO_2: {
    Import: null,
    Export: null,
    [LOB_ENUM.EXPORT_AND_IMPORT]: ["exp_imp_prospects_imp", "exp_imp_competitors_imp"],
  },
  LINE_OF_BUSINESS_INFO_2: {
    [LOB_ENUM.IMPORT]: null,
    [LOB_ENUM.EXPORT]: null,
    [LOB_ENUM.EXPORT_AND_IMPORT]: ["exp_imp_products_hscodes_imp"],
  },
};

export const BRANCHES = {
  USER_COMPANY_INFO: true,
  LINE_OF_BUSINESS_INFO_1: true,
  LINE_OF_BUSINESS_INFO_2: true,
  BUSINESS_INFO_1: true,
  BUSINESS_INFO_2: true,
};

export const LINE_OF_BUSINESS_MAP = {
  [LOB_ENUM.EXPORT]: LOB_ENUM.EXPORT,
  [LOB_ENUM.IMPORT]: LOB_ENUM.IMPORT,
  [LOB_ENUM.EXPORT_AND_IMPORT]: LOB_ENUM.EXPORT_AND_IMPORT,
  [LOB_ENUM.BUSINESS_DEVELOPMENT]: LOB_ENUM.BUSINESS_DEVELOPMENT,
  [LOB_ENUM.RESEARCH_AND_ANALYTICS]: LOB_ENUM.RESEARCH_AND_ANALYTICS,
  [LOB_ENUM.OTHER]: LOB_ENUM.OTHER,
};

export const PRE_FETCH_API_MAPS = {
  BUSINESS_INFO_1: {
    [LOB_ENUM.EXPORT]: {
      exp_prospects: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "consignee",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          includeFilters: ["outboundCountry"],
          outboundCountry: [requestObject.userCountry],
          outboundCountryRegion: [],
        }),
        extractionDepth: `data.data`,
        saveToKey: "exp_prospects",
      },
      exp_competitors: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "shipper",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          includeFilters: ["outboundCountry"],
          outboundCountry: [requestObject.userCountry],
          outboundCountryRegion: [],
        }),
        extractionDepth: `data.data`,
        saveToKey: "exp_competitors",
      },
      exp_customers: {
        apiEndPoint: "profileMapData",
        payload: (requestObject) => ({
          profile_type: "company",
          order: "desc",
          must_not: [],
          isSubsidiaryIncluded: true,
          search: null,
          sub_category: "trading_partner",
          map_type: "",
          _id: requestObject.companyId,
          slug: requestObject.slug,
          category: "exporters",
        }),
        extractionDepth: `data.data.trading_partner`,
        saveToKey: "exp_customers",
      },
    },
    [LOB_ENUM.IMPORT]: {
      imp_prospects: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "shipper",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          inboundCountry: [requestObject.userCountry],
          inboundCountryRegion: [],
          includeFilters: ["inboundCountry"],
        }),
        extractionDepth: `data.data`,
        saveToKey: "imp_prospects",
      },
      imp_competitors: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "consignee",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          inboundCountry: [requestObject.userCountry],
          inboundCountryRegion: [],
          includeFilters: ["inboundCountry"],
        }),
        extractionDepth: `data.data`,
        saveToKey: "imp_competitors",
      },
    },
    [LOB_ENUM.EXPORT_AND_IMPORT]: {
      exp_imp_prospects_exp: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "consignee",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          includeFilters: ["outboundCountry"],
          outboundCountry: [requestObject.userCountry],
          outboundCountryRegion: [],
        }),
        extractionDepth: `data.data`,
        saveToKey: "exp_imp_prospects_exp",
      },
      exp_imp_competitors_exp: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "shipper",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          includeFilters: ["outboundCountry"],
          outboundCountry: [requestObject.userCountry],
          outboundCountryRegion: [],
        }),
        extractionDepth: `data.data`,
        saveToKey: "exp_imp_competitors_exp",
      },
      exp_imp_customers_exp: {
        apiEndPoint: "profileMapData",
        payload: (requestObject) => ({
          profile_type: "company",
          order: "desc",
          must_not: [],
          isSubsidiaryIncluded: true,
          search: null,
          sub_category: "trading_partner",
          map_type: "",
          _id: requestObject.companyId,
          slug: requestObject.slug,
          category: "exporters",
        }),
        extractionDepth: `data.data.trading_partner`,
        saveToKey: "exp_imp_customers_exp",
      },
    },
  },
  BUSINESS_INFO_2: {
    Import: null,
    Export: null,
    [LOB_ENUM.BUSINESS_DEVELOPMENT]: null,
    [LOB_ENUM.OTHER]: null,
    [LOB_ENUM.RESEARCH_AND_ANALYTICS]: null,
    [LOB_ENUM.EXPORT_AND_IMPORT]: {
      exp_imp_prospects_imp: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "shipper",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          inboundCountry: [requestObject.userCountry],
          inboundCountryRegion: [],
          includeFilters: ["inboundCountry"],
        }),
        extractionDepth: `data.data`,
        saveToKey: "exp_imp_prospects_imp",
      },
      exp_imp_competitors_imp: {
        apiEndPoint: "intelSearchMultiCountry",
        payload: (requestObject) => ({
          from: 0,
          sort: "date",
          search_type: "basic",
          order: "desc",
          companyType: "consignee",
          analyticsField: false,
          reload: false,
          is_from_alert: "",
          hscode_profile_key: "",
          companyKey: "",
          companyPageNo: 1,
          searchEnable: false,
          isMerged: false,
          isSubsidiaryIncluded: false,
          customType: "shipments",
          redirectingProfile: "",
          redirectingProfilePartner: "",
          is_from_autosuggest: false,
          fromDate: requestObject.fromDate,
          toDate: requestObject.toDate,
          search: "",
          key: "entire_bill_of_lading",
          queryType: "contains",
          is_chemical: false,
          dataSource: [...requestObject.dataSource],
          derivedConsigneeMasterNameAndIdMapping: [],
          derivedShipperMasterNameAndIdMapping: [],
          must_not: [],
          uniqueImportExporterShipment: [],
          uniqueImportExporterWeight: [],
          uniqueImportExporterValue: [],
          internalSortOrder: "",
          isSecondLevelAnalytics: false,
          isTrends: false,
          trendType: "year",
          inboundCountry: [requestObject.userCountry],
          inboundCountryRegion: [],
          includeFilters: ["inboundCountry"],
        }),
        extractionDepth: `data.data`,
        saveToKey: "exp_imp_competitors_imp",
      },
    },
  },
  LINE_OF_BUSINESS_INFO_1: {
    [LOB_ENUM.IMPORT]: [
      {
        apiEndPoint: "intelMultiCountryCompanySearch",
        payload: (requestObject) => ({
          companyName: requestObject.companyName,
          probableMatchesLimit: 1,
        }),
        extractionDepth: `data.data?.companies[0]`,
        saveToKey: "companyData",
      },
      {
        apiEndPoint: "profileMapData",
        payload: (requestObject) => ({
          profile_type: "company",
          order: "desc",
          must_not: [],
          isSubsidiaryIncluded: true,
          search: null,
          sub_category: "hs_code",
          map_type: "",
          _id: requestObject.companyId,
          slug: requestObject.slug,
          category: "importers",
        }),
        extractionDepth: `data.data.hs_code`,
        saveToKey: "imp_products_hscodes",
      },
    ],
    [LOB_ENUM.EXPORT]: [
      {
        apiEndPoint: "intelMultiCountryCompanySearch",
        payload: (requestObject) => ({
          companyName: requestObject.companyName,
          probableMatchesLimit: 1,
        }),
        extractionDepth: `data.data?.companies[0]`,
        saveToKey: "companyData",
      },
      {
        apiEndPoint: "profileMapData",
        payload: (requestObject) => ({
          profile_type: "company",
          order: "desc",
          must_not: [],
          isSubsidiaryIncluded: true,
          search: null,
          sub_category: "hs_code",
          map_type: "",
          _id: requestObject.companyId,
          slug: requestObject.slug,
          category: "exporters",
        }),
        extractionDepth: `data.data.hs_code`,
        saveToKey: "exp_products_hscodes",
      },
    ],
  },
};

export const AUTOSUGGEST_API_MAP = {
  BUSINESS_INFO_1: {
    [LOB_ENUM.EXPORT]: {
      exp_prospects: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      exp_customers: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      exp_competitors: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
    },
    [LOB_ENUM.IMPORT]: {
      imp_prospects: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      imp_competitors: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
    },
    [LOB_ENUM.EXPORT_AND_IMPORT]: {
      exp_imp_prospects_exp: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      exp_imp_customers_exp: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      exp_imp_competitors_exp: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
    },
    [LOB_ENUM.BUSINESS_DEVELOPMENT]: {
      bd_ports: {
        api: (value) => `allCategoryAutoSuggest?country=multicountry&lang=EN&country_code=world&data_source=import&search=${value}&tab=onboarding`,
        params: {
          value: "value",
        },
      },
    },
  },
  BUSINESS_INFO_2: {
    [LOB_ENUM.IMPORT]: {
      imp_prospects: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      imp_competitors: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
    },
    [LOB_ENUM.EXPORT_AND_IMPORT]: {
      exp_imp_prospects_imp: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      exp_imp_customers_imp: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
      exp_imp_competitors_imp: {
        api: (value) => `companyProfiles/getCompanyAutoSuggest?hint=${value}&type=E&country_code=world&data_source=import`,
        params: {
          company: "company",
        },
      },
    },
  },
  LINE_OF_BUSINESS_INFO_1: {
    [LOB_ENUM.IMPORT]: {
      imp_products_hscodes: {
        api: (value) => `allCategoryAutoSuggest?data_source=import&search=${value}&tab=onboarding`,
        params: {
          value: "value",
        },
      },
    },
    [LOB_ENUM.EXPORT]: {
      exp_products_hscodes: {
        api: (value) => `allCategoryAutoSuggest?data_source=import&search=${value}&tab=onboarding`,
        params: {
          value: "value",
        },
      },
    },
    [LOB_ENUM.EXPORT_AND_IMPORT]: {
      exp_imp_products_hscodes_exp: {
        api: (value) => `allCategoryAutoSuggest?data_source=import&search=${value}&tab=onboarding`,
        params: {
          value: "value",
        },
      },
    },
  },
  LINE_OF_BUSINESS_INFO_2: {
    [LOB_ENUM.EXPORT_AND_IMPORT]: {
      exp_imp_products_hscodes_imp: {
        api: (value) => `allCategoryAutoSuggest?data_source=import&search=${value}&tab=onboarding`,
        params: {
          value: "value",
        },
      },
    },
  },
};

export const SLICE_MAPS = {
  country: 2,
  user_company_profile: 2,
  exp_products_hscodes: 5,
  imp_products_hscodes: 5,
  exp_imp_products_hscodes_exp: 5,
  exp_imp_products_hscodes_imp: 5,

  exp_prospects: 2,
  exp_customers: 2,
  exp_competitors: 2,
  imp_prospects: 2,
  imp_competitors: 2,
  exp_imp_prospects_exp: 2,
  exp_imp_customers_exp: 2,
  exp_imp_competitors_exp: 2,
  exp_imp_prospects_imp: 2,
  exp_imp_competitors_imp: 2,
  bd_countries: 4,
  bd_ports: 4,
  bd_industry_segments: 4,
  business_size: 4,
  ra_countries: 4,
  ra_industry_segments: 4,
};
